function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/downcast
 */
import TableWalker from './../tablewalker';
import { setHighlightHandling, toWidget, toWidgetEditable } from 'ckeditor5/src/widget';
import { toArray } from 'ckeditor5/src/utils';
/**
 * Model table element to view table element conversion helper.
 *
 * This conversion helper creates the whole table element with child elements.
 *
 * @param {Object} options
 * @param {Boolean} options.asWidget If set to `true`, the downcast conversion will produce a widget.
 * @returns {Function} Conversion helper.
 */

export function downcastInsertTable() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (dispatcher) {
    return dispatcher.on('insert:table', function (evt, data, conversionApi) {
      var table = data.item;

      if (!conversionApi.consumable.consume(table, 'insert')) {
        return;
      } // Consume attributes if present to not fire attribute change downcast


      conversionApi.consumable.consume(table, 'attribute:headingRows:table');
      conversionApi.consumable.consume(table, 'attribute:headingColumns:table');
      var asWidget = options && options.asWidget;
      var figureElement = conversionApi.writer.createContainerElement('figure', {
        class: 'table'
      });
      var tableElement = conversionApi.writer.createContainerElement('table');
      conversionApi.writer.insert(conversionApi.writer.createPositionAt(figureElement, 0), tableElement);
      var tableWidget;

      if (asWidget) {
        tableWidget = toTableWidget(figureElement, conversionApi.writer);
      }

      var tableWalker = new TableWalker(table);
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // Cache for created table rows.

      var viewRows = new Map();

      var _iterator = _createForOfIteratorHelper(tableWalker),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var tableSlot = _step.value;
          var row = tableSlot.row,
              cell = tableSlot.cell;
          var tableRow = table.getChild(row);
          var trElement = viewRows.get(row) || createTr(tableElement, tableRow, row, tableAttributes, conversionApi);
          viewRows.set(row, trElement); // Consume table cell - it will be always consumed as we convert whole table at once.

          conversionApi.consumable.consume(cell, 'insert');
          var insertPosition = conversionApi.writer.createPositionAt(trElement, 'end');
          createViewTableCellElement(tableSlot, tableAttributes, insertPosition, conversionApi, options);
        } // Insert empty TR elements if there are any rows without anchored cells. Since the model is always normalized
        // this can happen only in the document fragment that only part of the table is down-casted.

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(table.getChildren()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _tableRow = _step2.value;
          var rowIndex = _tableRow.index; // Make sure that this is a table row and not some other element (i.e., caption).

          if (_tableRow.is('element', 'tableRow') && !viewRows.has(rowIndex)) {
            viewRows.set(rowIndex, createTr(tableElement, _tableRow, rowIndex, tableAttributes, conversionApi));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var viewPosition = conversionApi.mapper.toViewPosition(data.range.start);
      conversionApi.mapper.bindElements(table, asWidget ? tableWidget : figureElement);
      conversionApi.writer.insert(viewPosition, asWidget ? tableWidget : figureElement);
    });
  };
}
/**
 * Model row element to view `<tr>` element conversion helper.
 *
 * This conversion helper creates the whole `<tr>` element with child elements.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastInsertRow() {
  return function (dispatcher) {
    return dispatcher.on('insert:tableRow', function (evt, data, conversionApi) {
      var tableRow = data.item;

      if (!conversionApi.consumable.consume(tableRow, 'insert')) {
        return;
      }

      var table = tableRow.parent;
      var figureElement = conversionApi.mapper.toViewElement(table);
      var tableElement = getViewTable(figureElement);
      var row = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        row: row
      });
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // Cache for created table rows.

      var viewRows = new Map();

      var _iterator3 = _createForOfIteratorHelper(tableWalker),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tableSlot = _step3.value;
          var trElement = viewRows.get(row) || createTr(tableElement, tableRow, row, tableAttributes, conversionApi);
          viewRows.set(row, trElement); // Consume table cell - it will be always consumed as we convert whole row at once.

          conversionApi.consumable.consume(tableSlot.cell, 'insert');
          var insertPosition = conversionApi.writer.createPositionAt(trElement, 'end');
          createViewTableCellElement(tableSlot, tableAttributes, insertPosition, conversionApi, {
            asWidget: true
          });
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    });
  };
}
/**
 * Model table cell element to view `<td>` or `<th>` element conversion helper.
 *
 * This conversion helper will create proper `<th>` elements for table cells that are in the heading section (heading row or column)
 * and `<td>` otherwise.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastInsertCell() {
  return function (dispatcher) {
    return dispatcher.on('insert:tableCell', function (evt, data, conversionApi) {
      var tableCell = data.item;

      if (!conversionApi.consumable.consume(tableCell, 'insert')) {
        return;
      }

      var tableRow = tableCell.parent;
      var table = tableRow.parent;
      var rowIndex = table.getChildIndex(tableRow);
      var tableWalker = new TableWalker(table, {
        row: rowIndex
      });
      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      }; // We need to iterate over a table in order to get proper row & column values from a walker

      var _iterator4 = _createForOfIteratorHelper(tableWalker),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var tableSlot = _step4.value;

          if (tableSlot.cell === tableCell) {
            var trElement = conversionApi.mapper.toViewElement(tableRow);
            var insertPosition = conversionApi.writer.createPositionAt(trElement, tableRow.getChildIndex(tableCell));
            createViewTableCellElement(tableSlot, tableAttributes, insertPosition, conversionApi, {
              asWidget: true
            }); // No need to iterate further.

            return;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    });
  };
}
/**
 * Conversion helper that acts on heading column table attribute change.
 *
 * Depending on changed attributes this converter will rename `<td` to `<th>` elements or vice versa depending on the cell column index.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastTableHeadingColumnsChange() {
  return function (dispatcher) {
    return dispatcher.on('attribute:headingColumns:table', function (evt, data, conversionApi) {
      var table = data.item;

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var tableAttributes = {
        headingRows: table.getAttribute('headingRows') || 0,
        headingColumns: table.getAttribute('headingColumns') || 0
      };
      var oldColumns = data.attributeOldValue;
      var newColumns = data.attributeNewValue;
      var lastColumnToCheck = (oldColumns > newColumns ? oldColumns : newColumns) - 1;

      var _iterator5 = _createForOfIteratorHelper(new TableWalker(table, {
        endColumn: lastColumnToCheck
      })),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var tableSlot = _step5.value;
          renameViewTableCellIfRequired(tableSlot, tableAttributes, conversionApi);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    });
  };
}
/**
 * Conversion helper that acts on a removed row.
 *
 * @returns {Function} Conversion helper.
 */

export function downcastRemoveRow() {
  return function (dispatcher) {
    return dispatcher.on('remove:tableRow', function (evt, data, conversionApi) {
      // Prevent default remove converter.
      evt.stop();
      var viewWriter = conversionApi.writer;
      var mapper = conversionApi.mapper;
      var viewStart = mapper.toViewPosition(data.position).getLastMatchingPosition(function (value) {
        return !value.item.is('element', 'tr');
      });
      var viewItem = viewStart.nodeAfter;
      var tableSection = viewItem.parent;
      var viewTable = tableSection.parent; // Remove associated <tr> from the view.

      var removeRange = viewWriter.createRangeOn(viewItem);
      var removed = viewWriter.remove(removeRange);

      var _iterator6 = _createForOfIteratorHelper(viewWriter.createRangeIn(removed).getItems()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var child = _step6.value;
          mapper.unbindViewElement(child);
        } // Cleanup: Ensure that thead & tbody sections are removed if left empty after removing rows. See #6437, #6391.

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      removeTableSectionIfEmpty('thead', viewTable, conversionApi);
      removeTableSectionIfEmpty('tbody', viewTable, conversionApi);
    }, {
      priority: 'higher'
    });
  };
}
/**
 * Overrides paragraph inside table cell conversion.
 *
 * This converter:
 * * should be used to override default paragraph conversion in the editing view.
 * * It will only convert <paragraph> placed directly inside <tableCell>.
 * * For a single paragraph without attributes it returns `<span>` to simulate data table.
 * * For all other cases it returns `<p>` element.
 *
 * @param {module:engine/model/element~Element} modelElement
 * @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
 * @returns {module:engine/view/containerelement~ContainerElement|undefined}
 */

export function convertParagraphInTableCell(modelElement, conversionApi) {
  var writer = conversionApi.writer;

  if (!modelElement.parent.is('element', 'tableCell')) {
    return;
  }

  if (isSingleParagraphWithoutAttributes(modelElement)) {
    return writer.createContainerElement('span', {
      class: 'ck-table-bogus-paragraph'
    });
  } else {
    return writer.createContainerElement('p');
  }
}
/**
 * Checks if given model `<paragraph>` is an only child of a parent (`<tableCell>`) and if it has any attribute set.
 *
 * The paragraph should be converted in the editing view to:
 *
 * * If returned `true` - to a `<span class="ck-table-bogus-paragraph">`
 * * If returned `false` - to a `<p>`
 *
 * @param {module:engine/model/element~Element} modelElement
 * @returns {Boolean}
 */

export function isSingleParagraphWithoutAttributes(modelElement) {
  var tableCell = modelElement.parent;
  var isSingleParagraph = tableCell.childCount === 1;
  return isSingleParagraph && !hasAnyAttribute(modelElement);
} // Converts a given {@link module:engine/view/element~Element} to a table widget:
// * Adds a {@link module:engine/view/element~Element#_setCustomProperty custom property} allowing to recognize the table widget element.
// * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
//
// @param {module:engine/view/element~Element} viewElement
// @param {module:engine/view/downcastwriter~DowncastWriter} writer An instance of the view writer.
// @param {String} label The element's label. It will be concatenated with the table `alt` attribute if one is present.
// @returns {module:engine/view/element~Element}

function toTableWidget(viewElement, writer) {
  writer.setCustomProperty('table', true, viewElement);
  return toWidget(viewElement, writer, {
    hasSelectionHandle: true
  });
} // Renames an existing table cell in the view to a given element name.
//
// **Note** This method will not do anything if a view table cell has not been converted yet.
//
// @param {module:engine/model/element~Element} tableCell
// @param {String} desiredCellElementName
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function renameViewTableCell(tableCell, desiredCellElementName, conversionApi) {
  var viewWriter = conversionApi.writer;
  var viewCell = conversionApi.mapper.toViewElement(tableCell);
  var editable = viewWriter.createEditableElement(desiredCellElementName, viewCell.getAttributes());
  var renamedCell = toWidgetEditable(editable, viewWriter);
  setHighlightHandling(renamedCell, viewWriter, function (element, descriptor, writer) {
    return writer.addClass(toArray(descriptor.classes), element);
  }, function (element, descriptor, writer) {
    return writer.removeClass(toArray(descriptor.classes), element);
  });
  viewWriter.insert(viewWriter.createPositionAfter(viewCell), renamedCell);
  viewWriter.move(viewWriter.createRangeIn(viewCell), viewWriter.createPositionAt(renamedCell, 0));
  viewWriter.remove(viewWriter.createRangeOn(viewCell));
  conversionApi.mapper.unbindViewElement(viewCell);
  conversionApi.mapper.bindElements(tableCell, renamedCell);
} // Renames a table cell element in the view according to its location in the table.
//
// @param {module:table/tablewalker~TableSlot} tableSlot
// @param {{headingColumns, headingRows}} tableAttributes
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function renameViewTableCellIfRequired(tableSlot, tableAttributes, conversionApi) {
  var cell = tableSlot.cell; // Check whether current columnIndex is overlapped by table cells from previous rows.

  var desiredCellElementName = getCellElementName(tableSlot, tableAttributes);
  var viewCell = conversionApi.mapper.toViewElement(cell); // If in single change we're converting attribute changes and inserting cell the table cell might not be inserted into view
  // because of child conversion is done after parent.

  if (viewCell && viewCell.name !== desiredCellElementName) {
    renameViewTableCell(cell, desiredCellElementName, conversionApi);
  }
} // Creates a table cell element in the view.
//
// @param {module:table/tablewalker~TableSlot} tableSlot
// @param {module:engine/view/position~Position} insertPosition
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function createViewTableCellElement(tableSlot, tableAttributes, insertPosition, conversionApi, options) {
  var asWidget = options && options.asWidget;
  var cellElementName = getCellElementName(tableSlot, tableAttributes);
  var cellElement = asWidget ? toWidgetEditable(conversionApi.writer.createEditableElement(cellElementName), conversionApi.writer) : conversionApi.writer.createContainerElement(cellElementName);

  if (asWidget) {
    setHighlightHandling(cellElement, conversionApi.writer, function (element, descriptor, writer) {
      return writer.addClass(toArray(descriptor.classes), element);
    }, function (element, descriptor, writer) {
      return writer.removeClass(toArray(descriptor.classes), element);
    });
  }

  var tableCell = tableSlot.cell;
  var firstChild = tableCell.getChild(0);
  var isSingleParagraph = tableCell.childCount === 1 && firstChild.name === 'paragraph';
  conversionApi.writer.insert(insertPosition, cellElement);
  conversionApi.mapper.bindElements(tableCell, cellElement); // Additional requirement for data pipeline to have backward compatible data tables.

  if (!asWidget && isSingleParagraph && !hasAnyAttribute(firstChild)) {
    var innerParagraph = tableCell.getChild(0);
    conversionApi.consumable.consume(innerParagraph, 'insert');
    conversionApi.mapper.bindElements(innerParagraph, cellElement);
  }
} // Creates a `<tr>` view element.
//
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/model/element~Element} tableRow
// @param {Number} rowIndex
// @param {{headingColumns, headingRows}} tableAttributes
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @returns {module:engine/view/element~Element}


function createTr(tableElement, tableRow, rowIndex, tableAttributes, conversionApi) {
  // Will always consume since we're converting <tableRow> element from a parent <table>.
  conversionApi.consumable.consume(tableRow, 'insert');
  var trElement = tableRow.isEmpty ? conversionApi.writer.createEmptyElement('tr') : conversionApi.writer.createContainerElement('tr');
  conversionApi.mapper.bindElements(tableRow, trElement);
  var headingRows = tableAttributes.headingRows;
  var tableSection = getOrCreateTableSection(getSectionName(rowIndex, tableAttributes), tableElement, conversionApi);
  var offset = headingRows > 0 && rowIndex >= headingRows ? rowIndex - headingRows : rowIndex;
  var position = conversionApi.writer.createPositionAt(tableSection, offset);
  conversionApi.writer.insert(position, trElement);
  return trElement;
} // Returns `th` for heading cells and `td` for other cells for the current table walker value.
//
// @param {module:table/tablewalker~TableSlot} tableSlot
// @param {{headingColumns, headingRows}} tableAttributes
// @returns {String}


function getCellElementName(tableSlot, tableAttributes) {
  var row = tableSlot.row,
      column = tableSlot.column;
  var headingColumns = tableAttributes.headingColumns,
      headingRows = tableAttributes.headingRows; // Column heading are all tableCells in the first `columnHeading` rows.

  var isColumnHeading = headingRows && headingRows > row; // So a whole row gets <th> element.

  if (isColumnHeading) {
    return 'th';
  } // Row heading are tableCells which columnIndex is lower then headingColumns.


  var isRowHeading = headingColumns && headingColumns > column;
  return isRowHeading ? 'th' : 'td';
} // Returns the table section name for the current table walker value.
//
// @param {Number} row
// @param {{headingColumns, headingRows}} tableAttributes
// @returns {String}


function getSectionName(row, tableAttributes) {
  return row < tableAttributes.headingRows ? 'thead' : 'tbody';
} // Creates or returns an existing `<tbody>` or `<thead>` element with caching.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} viewTable
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @param {Object} cachedTableSection An object that stores cached elements.
// @returns {module:engine/view/containerelement~ContainerElement}


function getOrCreateTableSection(sectionName, viewTable, conversionApi) {
  var viewTableSection = getExistingTableSectionElement(sectionName, viewTable);
  return viewTableSection ? viewTableSection : createTableSection(sectionName, viewTable, conversionApi);
} // Finds an existing `<tbody>` or `<thead>` element or returns undefined.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function getExistingTableSectionElement(sectionName, tableElement) {
  var _iterator7 = _createForOfIteratorHelper(tableElement.getChildren()),
      _step7;

  try {
    for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
      var tableSection = _step7.value;

      if (tableSection.name == sectionName) {
        return tableSection;
      }
    }
  } catch (err) {
    _iterator7.e(err);
  } finally {
    _iterator7.f();
  }
} // Creates a table section at the end of the table.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi
// @returns {module:engine/view/containerelement~ContainerElement}


function createTableSection(sectionName, tableElement, conversionApi) {
  var tableChildElement = conversionApi.writer.createContainerElement(sectionName);
  var insertPosition = conversionApi.writer.createPositionAt(tableElement, sectionName == 'tbody' ? 'end' : 0);
  conversionApi.writer.insert(insertPosition, tableChildElement);
  return tableChildElement;
} // Removes an existing `<tbody>` or `<thead>` element if it is empty.
//
// @param {String} sectionName
// @param {module:engine/view/element~Element} tableElement
// @param {module:engine/conversion/downcastdispatcher~DowncastConversionApi} conversionApi


function removeTableSectionIfEmpty(sectionName, tableElement, conversionApi) {
  var tableSection = getExistingTableSectionElement(sectionName, tableElement);

  if (tableSection && tableSection.childCount === 0) {
    conversionApi.writer.remove(conversionApi.writer.createRangeOn(tableSection));
  }
} // Finds a '<table>' element inside the `<figure>` widget.
//
// @param {module:engine/view/element~Element} viewFigure


function getViewTable(viewFigure) {
  var _iterator8 = _createForOfIteratorHelper(viewFigure.getChildren()),
      _step8;

  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var child = _step8.value;

      if (child.name === 'table') {
        return child;
      }
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
} // Checks if an element has any attributes set.
//
// @param {module:engine/model/element~Element element
// @returns {Boolean}


function hasAnyAttribute(element) {
  return !!_toConsumableArray(element.getAttributeKeys()).length;
}